<script>
  import { t } from "../../../core";
</script>

<svelte:head>
  <title>{t("NotFound.General.Title")}</title>
</svelte:head>

<section class="not-found g-centered">
  <h1 class="title">{t("NotFound.General.Title")}</h1>
</section>

<style lang="scss">
  .title {
    padding-top: 80px;
    padding-bottom: 100px;
    @include h1;
  }
</style>
